import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Product } from '../../core/models/interfaces-general';
import { UiEmptyImageComponent } from './ui-empty-image.component';

@Component({
  selector: 'app-product-card',
  standalone: true,
  imports: [CommonModule, RouterLink, UiEmptyImageComponent],
  template: `
    <a
      [routerLink]="product.url || null"
      (mouseenter)="isHovered = true"
      (mouseleave)="isHovered = false"
      class="cursor-pointer flex flex-col h-full rounded-3xl p-2 transition-all duration-300 hover:-translate-y-2 hover:shadow-xl bg-white select-none"
    >
      <!-- MARCO DE LA IMAGEN CON CORNER ROUNDED GRANDE -->
      <div class="relative w-full aspect-square rounded-2xl overflow-hidden bg-gray-100">
        
        <!-- Badge de Descuento (Si aplica) -->
        <div 
          *ngIf="product.discountPercentage"
          class="absolute top-3 left-3 z-20 px-3 py-1 rounded-full text-white text-xs font-bold tracking-wider shadow-sm pointer-events-none"
          style="background-color: var(--bg-main);"
        >
          -{{ product.discountPercentage }}% OFF
        </div>

        <!-- IMAGEN 1 (Principal) -->
        <app-ui-empty-image *ngIf="!product.images[0]" iconClass="w-12 h-12"></app-ui-empty-image>
        <img 
          *ngIf="product.images[0]"
          [src]="product.images[0]" 
          [alt]="product.name"
          class="absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-500 ease-in-out"
          [class.opacity-0]="isHovered && product.images.length > 1"
          [class.opacity-100]="!isHovered || product.images.length === 1"
        />

        <!-- IMAGEN 2 (Cambio suave solo al hacer hover en ESTA tarjeta) -->
        <img 
          *ngIf="product.images.length > 1"
          [src]="product.images[1]" 
          [alt]="product.name"
          class="absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-500 ease-in-out"
          [class.opacity-100]="isHovered"
          [class.opacity-0]="!isHovered"
        />

      </div>

      <!-- DETALLES DEL PRODUCTO -->
      <div class="mt-4 px-1 flex flex-col flex-grow justify-between">
        <!-- Nombre del Producto -->
        <h3 class="text-sm sm:text-base font-semibold text-gray-800 line-clamp-2 leading-tight">
          {{ product.name }}
        </h3>

        <!-- Precios -->
        <div class="mt-2 flex items-center gap-2 flex-wrap">
          <!-- Precio Original Tachado (Opcional) -->
          <span 
            *ngIf="product.originalPrice" 
            class="text-xs sm:text-sm line-through font-normal"
            style="color: var(--text-accent);"
          >
            {{ product.currency || 'S/' }}{{ product.originalPrice | number:'1.2-2' }}
          </span>

          <!-- Precio de Oferta Resaltado -->
          <span 
            class="text-sm sm:text-base font-bold"
            style="color: var(--bg-main);"
          >
            {{ product.currency || 'S/' }}{{ product.discountPrice | number:'1.2-2' }}
          </span>
        </div>
      </div>
    </a>
  `
})
export class ProductCardComponent {
  @Input({ required: true }) product!: Product;

  // Estado local e independiente por cada tarjeta
  isHovered: boolean = false;
}